import { getCognitoIdToken } from "@src/appV2/Auth/cognito/cognitoAuth";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";

export async function getAuthHeader(): Promise<{ Authorization: string | null }> {
  try {
    const cognitoToken = await getCognitoIdToken();
    if (cognitoToken) {
      return { Authorization: `Bearer ${cognitoToken}` };
    }
  } catch (error: unknown) {
    logError(APP_V2_APP_EVENTS.GET_COGNITO_TOKEN_FAILURE, {
      error,
      metadata: { source: "superagent-helper" },
    });
    // Fall through — request fires unauthenticated and the response 401 will
    // surface to the caller. The api.ts response interceptor's redirect path
    // covers axios callsites; legacy superagent callsites handle their own
    // errors.
  }

  /**
   * ***** WARNING ****
   *  `superagent` requires Authorization to either be a string, or null
   * DO NOT SET `Authorization` to `undefined` because you will break sign in flow
   * See https://app.datadoghq.com/incidents/102
   */
  return { Authorization: null };
}
